// ========================================
// TYPES
// ========================================

export type ProviderTier = 'economy' | 'standard' | 'premium'

export interface ModelConfig {
  default: {
    tiers: ProviderTier[]
  }
  defaultFallbackModel?: string
  models?: Record<string, {
    tiers?: ProviderTier[]
    fallbackModels?: string[]
  }>
}

/**
 * Default model configuration for users who haven't set preferences
 * This is the single source of truth for default tier preferences
 */
export const DEFAULT_MODEL_CONFIG: ModelConfig = {
  default: {
    tiers: ['economy', 'standard', 'premium'],
  },
  defaultFallbackModel: 'deepseek-v4-flash',
}
